<template>
  <div>
    <v-card class="mx-auto ml-5 my-5 mx-5 mr-5 " outlined>
      <highcharts :options="chartOptions" ref="highcharts"></highcharts>
      <!--<button @click="updateCredits">update credits</button>-->
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

import { VUE_APP_BASEURL } from "../utils/api";
import axios from "axios";
import store from "../store";

export default {
  name: "YearlyEnquiryBarchart",
  props: [
    "selectedsegment",
    "selectedsalesengineer",
    "selectedregion",
    "selectedproductgroup"
  ],
  data: () => ({
    chartOptions: {
      chart: {
        type: "column"
      },
      title: {
        text: "SALES PERFORMANCE REPORT"
      },
      subtitle: {
        text: ""
      },
      xAxis: {
        categories: [],
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: ""
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{}],
      credits: {
        enabled: false
      }
    }
  }),
  components: {},
  computed: {},
  mounted() {},
  created() {
    this.yearlyEnquirychartload(this.chartOptions);
  },
  methods: {
    yearlyEnquirychartload(chartOptions) {
      const filterData = [];
      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "chart/yearly-enquirydata",
        data: {
          segment: filterData.segment,
          salesengineer: filterData.salesengineer
        }
      })
        .then(function(response) {
          // console.log(response.data.response.reportDates);
          chartOptions.xAxis.categories = response.data.response.reportDates;
          chartOptions.series = response.data.response.enquiryData;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /* filterYearlychartReport() {
        const filterData = {
        segment: this.selectedsegment,
        salesengineer: this.selectedsalesengineer,
      };
      console.log(filterData);
      this.yearlyEnquirychart(filterData);
      setTimeout(() => {
        this.chartOptions.series=this.chartData.enquiryData;
        this.chartOptions.xAxis.categories=this.chartData.reportDates;
        //console.log('updated');
        }, 3000)
    },*/

    filterYearlychartReport() {
      const filterData = {
        segment: this.selectedsegment,
        salesengineer: this.selectedsalesengineer,
        region: this.selectedregion,
        productgroup: this.selectedproductgroup
      };
      // console.log(filterData);

      const chartOptions = this.chartOptions;
      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "chart/yearly-enquirydata",
        data: {
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          region: filterData.region,
          productgroup: filterData.productgroup
        }
      })
        .then(function(response) {
          //   console.log(response);
          chartOptions.xAxis.categories = response.data.response.reportDates;
          chartOptions.series = response.data.response.enquiryData;
        })
        .catch(function(error) {
          console.log(error.response);
        });
    }
  }
};
</script>
